export default __webpack_public_path__ + "static/media/add-member-grey.b25ea78f.svg";